/**
 * The cashier's sales summary. Port of web `printHelper.js` `printSalesummary` (:680).
 *
 * The one document that relays to the master on `isSlave()` ALONE — the `printBillFromMaster`
 * device setting gates bills, not this. v1 does the same on both platforms.
 */
import { renderSalesSummaryContent } from "../content";
import type { Plan, PrintContext, SalesSummaryInput } from "../types";
import { isEmpty } from "../util";

export function planSalesSummary(input: SalesSummaryInput, ctx: PrintContext): Plan {
  const printer = input.printer ?? ctx.printers.defaultPrinter ?? {};
  const relay = ctx.device.isSlave;
  // v1 sends to the empty printer and fails in the shell; its one caller already guards this
  if (!relay && isEmpty(printer)) return { pieces: [], skipped: [{ reason: "noDefaultPrinter" }] };

  // v1 mobile passes `printer?.printWidth` with no default, so a printer without one lays out at
  // no width (PRINTING.md §9 row 14). Web's `?? 46` wins.
  const text = renderSalesSummaryContent(input.summary, printer?.printWidth ?? 46);
  return {
    pieces: [
      {
        document: "salesSummary",
        destination: relay ? { to: "relay" } : { to: "printer", printer },
        copies: 1,
        source: { kind: "text", text },
      },
    ],
    skipped: [],
  };
}
